import bus from '@/utils/eventBus'

export default function () {
  bus.$on('get-events-common-area', values => {
    this.setCommomAreaId(values.id)
    // this.getCommonAreaById(values.id)
  })
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/resources/created.js